import React from "react";
import "./Backbutton.scss";
import gsap from "gsap";
import { useHistory } from "react-router";

function TopButtons() {
  let history = useHistory();
  // gsap.set('.top_effect',{x:'-100%'},3)

  // var lines = gsap.timeline({repeat:0}).to('.top_effect',1,{x:'0%'})

  return (
    // <div className="homepage_header mt-5">
    //     {/* <button className="homepage_button brand_button top_origin">BRANDS</button> */}
    //     {/* <button className="homepage_button brand_button top_effect">BRANDS</button>
    //     <button className="homepage_button about_button top_origin">ABOUT</button>  */}
    //     <button className="homepage_button about_button top_effect">ABOUT</button>
    // </div>
    <div>
      <div className="aboutButton" onClick={() => history.push("about-main")}>
        <button className="about_origin">ABOUT</button>
        <button className="about_effect">ABOUT</button>
      </div>
      <div className="brandButton" onClick={() => history.push("index")}>
        <button className="brand_origin">BRANDS</button>
        <button className="brand_effect">BRANDS</button>
      </div>
    </div>
  );
}

export default TopButtons;
